import { render, staticRenderFns } from "./ModattaChipScroll.vue?vue&type=template&id=287834c5&scoped=true"
import script from "./ModattaChipScroll.vue?vue&type=script&lang=js"
export * from "./ModattaChipScroll.vue?vue&type=script&lang=js"
import style0 from "./ModattaChipScroll.vue?vue&type=style&index=0&id=287834c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287834c5",
  null
  
)

export default component.exports